import React from 'react'
import { AppBar, Tabs, Tab } from '@mui/material'
import { a11yProps } from 'src/features/brands/components/figures'
import { useLocale } from 'src/locales/useLocale'

type Props = {
  selectedIndex: number
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>
}

export const SettingTabs: React.FC<Props> = ({ selectedIndex, setSelectedIndex }) => {
  const handleChange = (_, newValue: number) => setSelectedIndex(newValue)
  const { t } = useLocale()
  return (
    <AppBar position="sticky" style={{ top: 0 }}>
      <Tabs value={selectedIndex} onChange={handleChange} centered aria-label="settings-tab-wrapper">
        <Tab label={t.PARTS_SETTING} {...a11yProps(0)} style={tabStyle(0, selectedIndex)} />
        <Tab label={t.COLOR_SETTING} {...a11yProps(1)} style={tabStyle(1, selectedIndex)} />
        <Tab label={t.EMBROIDERY_SETTING} {...a11yProps(2)} style={tabStyle(2, selectedIndex)} />
      </Tabs>
    </AppBar>
  )
}

export const tabStyle = (tabIndex: number, selectedIndex: number) => {
  const isForcused = selectedIndex === tabIndex
  return { fontWeight: `${isForcused ? 'bold' : 'normal'}`, color: `${isForcused ? 'white' : '#ccc'}` } as React.CSSProperties
}
